import actionTypes from '../actionTypes/actionTypes';

export const initialState = {
  registered: false,
  register: false
}

function registerReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_REGISTER:
      return Object.assign({}, state, {
        register: action.data.register || false
      })
      break
    case actionTypes.REQUEST_REGISTERED:
      return Object.assign({}, state, {
        registered: action.data.registered || false
      })
      break
    default:
      return state
  }
}

export default registerReducer;